import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { User_Interface,Empty_User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-Cutomeruserform',
  templateUrl: './Cutomeruserform.component.html',
  styleUrls: ['./Cutomeruserform.component.scss']
})
export class CutomeruserformComponent implements OnInit {

  Token:String=""
  InProccessing:boolean=false
  EditRecord:number
  CustomerName:string=''
  CurrentUserName:String=''
  CurrentUserId:number=0

  constructor(
    private User_Service:UserService,
    private Nav_Service:NavService,
    private Customer_Service:CustomerService,
    private Alertify_Service:AlertifyService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))

    this.CustomerUser=new FormGroup({
      id :new FormControl(),
      Username:new FormControl(null,Validators.required),
      Password:new FormControl(null,[Validators.required,Validators.minLength(6)]),

    })

    this.Nav_Service.CheckValidPage(this.Token,16).subscribe(
      data=>{

        this.Customer_Service.GetSingleUser(this.Token,this.EditRecord).subscribe(
          data2=>{
            this.CurrentUserName=data2['username']
            this.CustomerName=data2['fname']
            this.CurrentUserId=data2['id']
            this.get_Form_Username().setValue(data2['username'])
          }
        )

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

    //#region  Form Add

    CustomerUser:FormGroup;

    get_Form_Username(){
      return this.CustomerUser.get('Username') as FormControl;
    }

    get_Form_Password(){
      return this.CustomerUser.get('Password') as FormControl;
    }

    //#endregion


    SubmitCustomerUser(){
      this.InProccessing=true

      var Record:User_Interface=Empty_User_Interface()
      Record.id=this.CurrentUserId
      Record.cutomer_id=this.EditRecord
      Record.username=this.get_Form_Username().value
      Record.password = this.get_Form_Password().value
      Record.type=3

      if(Record.id==0)
      {

        this.User_Service.AddUser(Record,this.Token,[],[],[],[],[]).subscribe(
          data=>{
            this.InProccessing=false
            if(data.id==-2){
              this.Alertify_Service.ErrorMessage("The entered username already exists in the list.")
            }
            else{
              this.CurrentUserName=this.get_Form_Username().value
              this.Alertify_Service.SuccessMessage("Information saved successfully.")
            }
          },error=>{
            localStorage.clear()
            location.reload();

          }
        )
      }
      else{

          this.User_Service.EditUser(Record,this.Token,[],[],[],[],[]).subscribe(
            data=>{
              this.InProccessing=false
              if(data.id==-2){
                this.Alertify_Service.ErrorMessage("The entered username already exists in the list.")
              }
              else{
                this.CurrentUserName=this.get_Form_Username().value
                this.Alertify_Service.SuccessMessage("Information saved successfully.")
              }
            },error=>{
              localStorage.clear()
              location.reload();

            }
          )

      }

    }

}
